import React, { useEffect, useState } from "react";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMap,
  ZoomControl,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "./Map.css";
import myicon from "../../assets/marker.png";
// import iconShadow from 'leaflet/dist/images/marker-shadow.png';

const defaultIcon = L.icon({
  iconUrl: myicon,
  // shadowUrl: iconShadow
  iconSize: [30, 30],
});

export default function Map({ selectedLocations, setSelectedLocations }) {
  const [center, setCenter] = useState([-37.818531, 144.949066]);

  function ResetCenterView({ selectPositionLat, selectPositionLng }) {
    const map = useMap();

    useEffect(() => {
      if (selectPositionLat && selectPositionLng) {
        map.setView(
          L.latLng(selectPositionLat, selectPositionLng),
          map.getZoom(),
          {
            animate: true,
          }
        );
      }
    }, [selectPositionLat, selectPositionLng]);

    return null;
  }

  return (
    <MapContainer
      center={center}
      zoom={10}
      className="delicious100-interactive__map"
      style={{ backgroundColor: "grey" }}
      fadeAnimation={true}
      markerZoomAnimation={true}
      touchZoom={false}
      // dragging={false}
      scrollWheelZoom={false}
      zoomControl={false}
      zoomAnimation={true}
    >
      <ZoomControl position="bottomright" />
      <TileLayer
        url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {selectedLocations &&
        selectedLocations?.["gps-lat"]?.map((dataObj, index) => {
          return (
            <Marker
              key={index}
              position={[dataObj, selectedLocations?.["gps-lng"]?.[index]]}
              icon={defaultIcon}
              eventHandlers={{
                click: (e) => {
                  // setSelectedLocations(dataObj);
                  setCenter([dataObj, selectedLocations?.["gps-lng"]?.[index]]);
                },
              }}
            >
              <Popup>{selectedLocations?.["review-copy"]}</Popup>
            </Marker>
          );
        })}
      {selectedLocations && (
        <ResetCenterView
          selectPositionLat={selectedLocations?.["gps-lat"]?.[0]}
          selectPositionLng={selectedLocations?.["gps-lng"]?.[0]}
        />
      )}
    </MapContainer>
  );
}
